import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getSubjects as getCustomersApi,
    getSubjectsFindOne as getCustomersFindOneApi,
    addSubject as addCustomerApi,
    updateSubject as updateCustomerApi,
    deleteSubject as deleteCustomerApi,
} from "./api";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export const getCustomers = createAsyncThunk("customers/getCustomers", async (filters: any, { rejectWithValue }) => {
    try {
        const response = await getCustomersApi(filters);
        return response;
    } catch (error: any) {
        const message = error?.response?.data?.message || "Ocurrió un error al obtener los clientes";
        toast.error(message, { autoClose: 3000 });
        return rejectWithValue(message);
    }
});

export const getCustomersFindOne = createAsyncThunk("customers/getCustomersFindOne", async (filters: any, { rejectWithValue }) => {
    try {
        const response = await getCustomersFindOneApi(filters);
        return response;
    } catch (error: any) {
        const message = error?.response?.data?.message || "Ocurrió un error al obtener el cliente";
        toast.error(message, { autoClose: 3000 });
        return rejectWithValue(message);
    }
});

export const addCustomer = createAsyncThunk("customers/addCustomer", async (customer: any, { rejectWithValue }) => {
    try {
        const response = await addCustomerApi(customer);
        toast.success("Cliente creado con éxito", { autoClose: 3000 });
        return response;
    } catch (error: any) {
        const message = error?.response?.data?.message || "Ocurrió un error al crear el cliente";
        toast.error(message, { autoClose: 3000 });
        return rejectWithValue(message);
    }
});

export const updateCustomer = createAsyncThunk("customers/updateCustomer", async ({ customer, showSuccessToast = true }: { customer: any; showSuccessToast?: boolean }, { rejectWithValue }) => {
    try {
        const response = await updateCustomerApi(customer.id, customer);
        if (showSuccessToast) {
            toast.success("El cliente se actualizó correctamente", { autoClose: 3000 });
        }
        return response;
    } catch (error: any) {
        const message = error?.response?.data?.message || "Ocurrió un error al actualizar el cliente";
        toast.error(message, { autoClose: 3000 });
        return rejectWithValue(message);
    }
});

export const deleteCustomer = createAsyncThunk("customers/deleteCustomer", async (id: any, { rejectWithValue }) => {
    try {
        await deleteCustomerApi(id);
        toast.success("El cliente ha sido eliminado con éxito", { autoClose: 2000 });
        return id;
    } catch (error: any) {
        const message = error?.response?.data?.message || "Ocurrió un error al eliminar el cliente";
        toast.error(message, { autoClose: 2000 });
        return rejectWithValue(message);
    }
});
